import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { ReleaseNoteFromApi } from '../scheduled-announcements/scheduled-announcements.typing';

@RegisterYCState()
export class ReleaseNoteState extends BaseYcState {
  readonly releaseNotes: ReleaseNoteFromApi[];
  readonly releaseNoteForManager: ReleaseNoteFromApi;
}
